function getImageURLByUserAgent(ua) {
  if (ua.device.manufacturer === "Apple") {
    if (ua.os.family.includes("Mac")) {
      return "https://firebasestorage.googleapis.com/v0/b/aksoa-company.appspot.com/o/mbp16-gray.png?alt=media&token=4c85b1d0-18a1-475a-ae1f-e358de3d6984";
    }
    if (ua.device.family.includes("iPhone")) {
      return "https://firebasestorage.googleapis.com/v0/b/aksoa-company.appspot.com/o/iPhone14Pro_VioletProfond_Front-Side_400x540px.png?alt=media&token=12730a0c-8d5e-424a-b768-535b0f715eae";
    }
    if (ua.device.family.includes("iPad")) {
      return "https://firebasestorage.googleapis.com/v0/b/aksoa-company.appspot.com/o/image-removebg-preview.png?alt=media&token=6632dcf3-a2a2-4ebc-b35c-343acee1ae66";
    }
  } else if (ua.os.family === "Android") {
    return "https://firebasestorage.googleapis.com/v0/b/aksoa-company.appspot.com/o/Android-PNG-Clipart-Background.png?alt=media&token=67cdbf96-e1b9-48c3-8569-ea9eee891cf2";
  } else if (ua.os.family.includes("Windows")) {
    return "https://firebasestorage.googleapis.com/v0/b/aksoa-company.appspot.com/o/image-removebg-preview%20(1).png?alt=media&token=a75cd0ad-5f21-4d2a-83d4-2b5296046dc9";
  } else if (ua.os.family.includes("Linux")) {
    return "https://firebasestorage.googleapis.com/v0/b/aksoa-company.appspot.com/o/linux-logo-logo-brands-for-0.png?alt=media&token=dc8b14b3-d524-4dad-b656-2b01c151d04e";
  } else {
    return "https://firebasestorage.googleapis.com/v0/b/aksoa-company.appspot.com/o/other-removebg-preview.png?alt=media&token=dccfc173-bbe0-4d52-baf6-85ebf3ccda52";
  }
}
// Générer un nombre aléatoire à 6 chiffres
const generateRandomNumber = () => {
  const min = 10000000; // Valeur minimale à 6 chiffres
  const max = 99999999; // Valeur maximale à 6 chiffres
  return Math.floor(Math.random() * (max - min + 1)) + min;
};
function genererIud() {
  const caracteresPermis =
    "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
  let chaine = "";
  for (let i = 0; i < 16; i++) {
    const indiceAleatoire = Math.floor(Math.random() * caracteresPermis.length);
    chaine += caracteresPermis.charAt(indiceAleatoire);
  }
  return chaine;
}
function generateKeywords(name) {
  // Supprime l'extension (par exemple, .png)
  const baseName = name.toLowerCase().split(".")[0];

  // Divise par les délimiteurs comme "-", "_" et espaces
  const parts = baseName.split(/[-_ ]/);

  // Génère toutes les combinaisons partielles
  const keywords = new Set();

  // Ajoute les mots individuels
  parts.forEach((part, index) => {
    let current = "";
    for (let i = 0; i <= part.length; i++) {
      current = part.slice(0, i);
      if (current) keywords.add(current);
    }
  });

  // Ajoute les combinaisons des mots
  for (let i = 1; i <= parts.length; i++) {
    keywords.add(parts.slice(0, i).join("-")); // Par exemple "bg-d"
    keywords.add(parts.slice(0, i).join("_")); // Par exemple "bg_d"
    keywords.add(parts.slice(0, i).join(" ")); // Par exemple "bg d"
  }

  return Array.from(keywords); // Convertit le Set en tableau
}

function formatDate(timestamp) {
  const date = new Date(timestamp);

  // Récupérer le jour, le mois et l'année
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Les mois sont indexés à partir de 0
  const year = date.getFullYear();

  // Concaténer les éléments pour former la date au format "jj/mm/aaaa"
  const formattedDate = `${day}/${month}/${year}`;

  return formattedDate;
}

const slugify = (str) =>
  str
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "") // Supprime les accents
    .replace(/[^a-z0-9 -]/g, "") // Conserve les lettres, chiffres, espaces et tirets
    .replace(/\s+/g, "-"); // Remplace les espaces par des tirets

export {
  slugify,
  genererIud,
  generateRandomNumber,
  getImageURLByUserAgent,
  generateKeywords,
  formatDate,
};
